import StudentLandingScreen from './containers/studentLandingScreen'

export {default as StudentLandingScreenLayout} from './components/studentLandingScreenLayout'

export default StudentLandingScreen
